module.exports = __webpack_public_path__ + "static/img/hidden-widget.8358845.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/widget/hidden-widget.png
// module id = nerA
// module chunks = 2